import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Box, Text, Input as SambaInput } from "samba-ui";

const Message = styled(Text)`
  ${p => (p.float ? `float: ${p.float};` : "")}
`;

Message.defaultProps = {
  fontSize: 0,
  fontWeight: 400
};

const Input = styled(SambaInput)`
  width: 100%;
  border-radius: 3px;
`;

// TODO @move-to-samba-ui
const Textarea = styled.textarea`
  min-height: 40px;
  width: 100%;
  margin-top: 8px;
  border-color: ${p =>
    p.error ? p.theme.colors.alert : "rgba(207, 214, 230, 1)"};
  border-radius: 3px;
  padding: 12px;
  box-sizing: border-box;
  font-size: ${p => p.theme.fontSizes[1]}px;
  &:focus {
    border-color: ${p =>
      p.error ? p.theme.colors.alert : "rgba(69, 119, 237, 1)"};
    color: ${p => p.theme.colors.secondary};
    outline: none;
  }
  &::-webkit-input-placeholder {
    color: ${p => p.theme.colors.palette.ink.light};
  }
  &::-moz-placeholder {
    color: ${p => p.theme.colors.palette.ink.light};
  }
  &:-ms-input-placeholder {
    color: ${p => p.theme.colors.palette.ink.light};
  }
  &:-moz-placeholder {
    color: ${p => p.theme.colors.palette.ink.light};
  }
`;

const InputBox = ({
  header,
  placeholder,
  value,
  onChange,
  onBlur,
  onFocus,
  description,
  error,
  touched,
  textarea,
  ...inputProps
}) => (
  <Box mb={2}>
    <Text
      as="label"
      fontWeight={1}
      lineHeight="24px"
      fontSize={0}
      color="palette.ink.light"
    >
      <Text fontWeight={400} color="palette.ink.light">
        {header}
      </Text>
      {touched && error ? (
        <Message color="alert" float="right">
          {error.isJoi ? error.annotate(true) : error.message}
        </Message>
      ) : null}
      {textarea ? (
        <Textarea
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          error={touched && error ? error : null}
          {...inputProps}
        />
      ) : (
        <Input
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          error={touched && error ? error : null}
          {...inputProps}
        />
      )}
      {description ? (
        <Message color="palette.ink.light">{description}</Message>
      ) : null}
    </Text>
  </Box>
);

export const InputPropTypes = PropTypes.shape({
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  error: PropTypes.shape({
    message: PropTypes.string,
    annotate: PropTypes.func
  }),
  touched: PropTypes.bool,
  textarea: PropTypes.bool
});

InputBox.propTypes = {
  ...InputPropTypes,
  header: PropTypes.string,
  placeholder: PropTypes.string,
  description: PropTypes.string
};

export default InputBox;
